module.exports = __webpack_public_path__ + "img/wh_uncollect.c271617d.png";